import { Component, OnInit, ViewChild } from '@angular/core';
import { ManageUsersService } from '@data/manageUsers/manage-users.service';
import { CommonConstants } from '@mpg-core/constants/common-constants';
import { LoadPanelOption } from '@shared/common-components/load-panel/load-panel.component';
import { CommonDataService } from '@shared/services/common-data.service';
import { PermissionService } from '@shared/services/permission.service'; // Generated by Copilot
import { DxDataGridComponent } from 'devextreme-angular';
import { custom } from 'devextreme/ui/dialog';
interface ManageUsers{
  firstName:string;
  lastName:string;
  speId:string;
  email:string;
  roleName:string;
  departmentName:string;
  mpgpsrUserId:number;
  wednesdayAccessFlag:boolean; // added for wedaccessRestrict
}

@Component({
    selector: 'app-manage-users',
    templateUrl: './manage-users.component.html',
    styleUrls: ['./manage-users.component.less'],
    standalone: false
})
export class ManageUsersComponent implements OnInit {

  loadingData=false;
  locked:boolean = false;
  manageUsersData: ManageUsers[] = [];
  getPSROnly: ManageUsers[] = [];
  saveUpdateData: any[] = [];

  roleNameData: any[]=[];

  departmentData: any[]=[];

  showLoadPanel: boolean = false;
  dataGrid: any; // added for wedaccessRestrict
  loadPanelOption:LoadPanelOption={
    closeOnOutsideClick:false,
    message:"loading...",
    visible:true,
    showPane:true,
    ofPosition:'#publishHistoryGrid',
    shadingColor:'rgba(0,0,0,0.05)'
  };

  editRow: any;

  editId: any;
  editEmail: any;
  userNotAllowed:boolean=false;
  roleBasedWedFlag:boolean=false; // added for wedaccessRestrict


  @ViewChild('dataGridManageUser', { static: false }) dataGridView!: DxDataGridComponent;
  customIDMsg: string = "SPE ID is associated with an existing user.";
  customEmailMsg: string = "";
  disManageUsers: boolean = false;
  prevData: any;
  prevSpid: any;
  reSetted: boolean = false;
  // Start added for wedaccessRestrict
  row: boolean;
  insertFlag: boolean=false;
  isAccessFlag: boolean=false;
  // End added for wedaccessRestrict 


  constructor(private manageUsers: ManageUsersService, private commonService: CommonDataService, private permissionService: PermissionService) { 
    this.fetchManageUsers();
    this.fetchRoles();
    this.fetchDepartment();
    this.updateRoleName = this.updateRoleName.bind(this);
    this.updateDeptName = this.updateDeptName.bind(this);
    this.customValidation = this.customValidation.bind(this);
    this.customIDValidation = this.customIDValidation.bind(this);
    this.customizeItem=this.customizeItem.bind(this); // added for wedaccessRestrict
    this.searchParamValidation = this.searchParamValidation.bind(this);

    // Permission check — use numeric permissionId via PermissionService — Generated by Copilot
    if(this.permissionService.hasReadOnlyAccess('Admin') || this.permissionService.hasReadOnlyAccess('Post-Production Admin')){
			this.disManageUsers=true;
		}
  }



  ngOnInit(): void {
  }

  onEditingStart(e : any){
    console.log(this.isAccessFlag); // added for wedaccessRestrict
    this.editRow = e.data;
    // Start added for wedaccessRestrict
    this.insertFlag=false;
    if(this.editRow.roleId === CommonConstants.PRODUCTION_ADMIN_COORDINATOR_ROLE_ID ||
      this.editRow.roleId === CommonConstants.POST_PRODUCTION_ADMIN){  
      this.isAccessFlag=true; 
    }else{
      this.isAccessFlag=false;
    }
    //End added for wedaccessRestrict
  }

  onEditCanceled(e: any) {
    // Reset the previous search parameter when form is cancelled
    this.prevSpid = null;
    this.prevData = null;
  }

  customValidation(params: any) {
    let email = this.manageUsersData.map((a:any) => a.email.toLowerCase());
    let psrEmail = this.getPSROnly.map((a:any) => a.email.toLowerCase());
    if(this.editRow != null && this.editRow != ""){
      if(this.editRow.email.toLowerCase() != params.value.toLowerCase() && email.includes(params.value.toLowerCase())){
        this.customEmailMsg = "User Email is not unique";
        return false;
      }else if(this.editRow.email.toLowerCase() != params.value.toLowerCase() && psrEmail.includes(params.value.toLowerCase())){
        this.customEmailMsg = "User Email is existing in PSR group";
        return false;
      }else {
        return true;
      }
    }else if(email.includes(params.value.toLowerCase())){
      this.customEmailMsg = "User Email is not unique";
      return false;
    }else{
      return true;
    }
  }

  customIDValidation(params: any) {
    let getSpeID = this.manageUsersData.map((a: any) => a.speId.toLowerCase());
    let psrId = this.getPSROnly.map((a: any) => a.speId.toLowerCase());
  
    if (this.editRow != null && this.editRow != "") {
      if (this.editRow.speId.toLowerCase() != params.value.toLowerCase() && getSpeID.includes(params.value.toLowerCase())) {
        this.customIDMsg = "SPE ID is associated with an existing user.";
        return false;
      } else if (this.editRow.speId.toLowerCase() != params.value.toLowerCase() && psrId.includes(params.value.toLowerCase())) {
        this.customIDMsg = "SPE ID is associated with an existing user.";
        return false;
      } else {
        return true;
      }
    } else if (getSpeID.includes(params.value.toLowerCase())) {
      this.customIDMsg = "SPE ID is associated with an existing user.";
      return false;
    } else {
      return true;
    }
  }

searchParamValidation(params: any) {
  if (params.value && params.value.trim() !== '') {
    if (params.data.searchParam != this.prevSpid) {
      this.showLoadPanel = true;
      return this.manageUsers.searchBySpeIdIDM(params.value.toLowerCase()).subscribe(
        res => {
          if (res.status == "SUCCESS") {
            // Check if serviceResult and userDetails exist
            if (res.serviceResult && res.serviceResult.userDetails) {
              // Check if Status is true
              if (res.serviceResult.userDetails.Status === true) {
                this.fillIDMUser(res.serviceResult, params.value);
                this.showLoadPanel = false;
                return true;
              } else {
                // Status is false, show error message from serviceResult
                this.resetFill(params.value);
                this.showLoadPanel = false;
                const errorMessage = res.serviceResult.errorMessage || "Selected user is in inactive state";
                this.customAlert(errorMessage);
                return false;
              }
            } else {
              // serviceResult or userDetails is null/not present
              this.resetFill(params.value);
              this.showLoadPanel = false;
              const errorMessage = res.errorDescription || "User not found";
              this.customAlert(errorMessage);
              return false;
            }
          } else {
            // res.status is not SUCCESS
            this.resetFill(params.value);
            this.showLoadPanel = false;
            const errorMessage = res.errorDescription || "Service unavailable. Please retry or contact app team if issue persists.";
            this.customAlert(errorMessage);
            return false;
          }
        },
        error => {
          // API call error
          this.resetFill(params.value);
          this.showLoadPanel = false;
          this.customAlert("Service unavailable. Please retry or contact app team if issue persists.");
          return false;
        }
      );
    } else {
      return true;
    }
  }
  return true;
}

  fillIDMUser(data: any, spe: any){
    var idmData=data.userDetails;
    this.dataGridView.instance.cellValue(0, "firstName", idmData["First Name"]);
    this.dataGridView.instance.cellValue(0, "lastName", idmData["Last Name"]);
    this.dataGridView.instance.cellValue(0, "email", idmData["Email"]);
    this.dataGridView.instance.cellValue(0, "speId", idmData["SPE User ID"]);
    this.prevData = data.userDetails.Email;
    this.prevSpid = spe;
  }

  resetFill(val: any){
    this.dataGridView.instance.cellValue(0, "lastName", "");
    this.dataGridView.instance.cellValue(0, "email", "");
    this.dataGridView.instance.cellValue(0, "firstName", "");
    this.dataGridView.instance.cellValue(0, "speId", "");
    this.prevData = null;
    this.prevSpid = val;
  }

  customAlert(message:any){

    const mpDialog = custom({

      showTitle: false,

      messageHtml: message,

      buttons: [


        {

            text: "Close",

            onClick: () => false

        }

      ]

    });



    mpDialog.show().then((dialogResult:any) => {});

  }

  fetchDepartment(){
    this.manageUsers.getDepartments().subscribe(
      res => {
        if(res.status=="SUCCESS"){
          if(res.serviceResult){
            this.departmentData = res.serviceResult;
          }
        }
      })
  }

  fetchRoles(){
    this.manageUsers.getRoles().subscribe(
      res => {
        if(res.status=="SUCCESS"){
          if(res.serviceResult){
            this.roleNameData = res.serviceResult;
          }
        }
      })
  }

  fetchManageUsers(){
    if(!this.loadingData){
      this.manageUsers.getManageUsers().subscribe(
        res => {
          if(res.status=="SUCCESS"){
            if(res.serviceResult){
              this.manageUsersData = res.serviceResult.filter((item: any) => item.hasOwnProperty("roleId") && item.roleId !== null);
              this.getPSROnly = res.serviceResult.filter((item: any) => item.hasOwnProperty("roleId") && item.roleId === null);
            }else{
              this.manageUsersData=[];
              this.loadingData=false;
            }
          }
        }
      )
    }
  }


  updateUsers(e:any){
    

    let key:any;
		let operation:string;
		if(e && e.changes.length){
		  this.showLoadPanel=true;
			key=e.changes[0].key;
			operation=e.changes[0].type;
			if(operation=='remove' && key){
				this.deleteUser(key.mpgpsrUserId, e);
			}
			else{
				this.saveUser(e, false);
			}
		}
  }

  deleteUser(id:number, e:any){
    this.manageUsers.checkPsrGroup(id).subscribe(
      r=>{
        if(r.status=="SUCCESS" && r.serviceResult==true){
          // this.manageUsersData = r.serviceResult;
          this.showLoadPanel=false;
          //   this.showLoadPanel = false;
    let msg = "<div>User is associated to distribution groups. Do you want to retain the user for Distribution?<br></div>";
    let customAlertDialog = custom({
      showTitle: false,
      messageHtml: msg,
      buttons: [
        { text: "Yes", onClick: () => {
          this.showLoadPanel = true;
          this.saveUser(e, true);
        } 
      },
       { text: "No", onClick: () => {
        this.manageUsers.deletUser(id).subscribe(
          r=>{
            if(r.status=="SUCCESS"){
              // this.manageUsersData = r.serviceResult;
              this.showLoadPanel=false;
            }
          }
        );
       }}
     ]
     });
   customAlertDialog.show()
   .then((dialogResult : any) => {
    
     });
        }else if(r.status=="SUCCESS" && r.serviceResult==false){
          this.manageUsers.deletUser(id).subscribe(
            r=>{
              if(r.status=="SUCCESS"){
                // this.manageUsersData = r.serviceResult;
                this.showLoadPanel=false;
              }
            }
          );

        }
      }
    )

  
    
  }

  saveUser( e: any, removeMPG: any){
    if(removeMPG == true){
      const newData = Object.assign({}, e.changes[0].key, {roleId: null, departmentId: null, roleName: null});
      this.manageUsers.saveUser(newData).subscribe(
        r=>{
          console.log(r);
          if(r.status=="SUCCESS" && r.serviceResult){
            // this.manageUsersData = r.serviceResult;

            // this.manageUsersData.push(r.serviceResult);
            // this.dataGridView.instance.refresh();
            this.fetchManageUsers();
            this.showLoadPanel=false;
          }
        }
      );

    }else{
      this.saveUpdateData = e.changes[0].data;
      let psrEmail = this.getPSROnly.map((a:any) => a.email.toLowerCase());
      if(psrEmail.includes(e.changes[0].data.email.toLowerCase())){
        const getMPGPSR = this.getPSROnly.filter((obj: any) => obj.email === e.changes[0].data.email);  
        Object.assign(this.saveUpdateData, {mpgpsrUserId: getMPGPSR[0].mpgpsrUserId});
        this.manageUsers.saveUser(this.saveUpdateData).subscribe(
          r=>{
            console.log(r);
            if(r.status=="SUCCESS" && r.serviceResult){
              // this.manageUsersData = r.serviceResult;

              // this.manageUsersData.push(r.serviceResult);
              // this.dataGridView.instance.refresh();
              this.fetchManageUsers();
              this.showLoadPanel=false;
            }
          }
        );
       
        }else{   
          
          // if(!data.length){
      //   this.showLoadPanel=false;
      //   return;
      // }

        if(e.changes[0].type=='insert' && e.changes[0].key){
          // let addVal = e.changes[0].data.email;
          this.manageUsers.saveUser(this.saveUpdateData).subscribe(
            r=>{
              console.log(r);
              if(r.status=="SUCCESS" && r.serviceResult){
                // this.manageUsersData = r.serviceResult;

                // this.manageUsersData.push(r.serviceResult);
                // this.dataGridView.instance.refresh();
                this.fetchManageUsers();
                this.showLoadPanel=false;
              }
            }
          );

        }
        
        if(e.changes[0].type=='update' && e.changes[0].key){
          this.manageUsers.saveUser(this.saveUpdateData).subscribe(
            r=>{
              console.log(r);
              if(r.status=="SUCCESS" && r.serviceResult){
                // this.manageUsersData.push(r.serviceResult);
                // this.dataGridView.instance.refresh();
                this.fetchManageUsers();
                this.showLoadPanel=false;
              }
            }
          );

        }

      }
    }
      


   
      
    
     
  }
  

  onAddUser(e:any){
    //this.dataGrid=e.component;
    // e.data.mpgpsrUserId = Math.max(...this.manageUsersData.map(o => o.mpgpsrUserId), 0) + 1;
    // Start added for wedaccessRestrict
    this.insertFlag=true;
    this.isAccessFlag=false;
    console.log("OnAddUser",this.insertFlag);
    // End added for wedaccessRestrict
    e.data.firstName="";
    e.data.lastName="";
    e.data.speId="";
    e.data.email="";
    e.data.roleName="";
    e.data.departmentName="";
   e.data.wednesdayAccessFlag=false; // added for wedaccessRestrict
    this.editRow = ""
    
  }

  updateRoleName(eventData: any, cellInfo: any) {
    if (cellInfo.setValue) {
      cellInfo.setValue(eventData.value);
        }
  }

  updateDeptName(eventData: any, cellInfo: any) {
    if (cellInfo.setValue) {
      cellInfo.setValue(eventData.value);
    }
  }

  // Start added for wedaccessRestrict
  customizeItem(item:any) { 
    //console.log(this.editRow==""); 
    //console.log(this.insertFlag);
    if ( item.dataField === "wednesdayAccessFlag" ){  
      if(this.insertFlag== true || this.isAccessFlag==false){
      item.visible = false;  
      }else{
        item.visible = false;
      }
    }
  }
  // End added for wedaccessRestrict  
  

}
